// NPM
import React from 'react';

// Components
import Description from 'src/components/Shared/Description'

const OurProcess = ({ sections }) => {
  const titleSection =  sections.find(s => s.uuid === "aboutUs_ourProcess-title")
  const contentSection =  sections.find(s => s.uuid === "aboutUs_ourProcess-content")

  if(titleSection && contentSection) {
    return (
      <div className="OurProcess">
        <div className="OurProcess__inner">
          <h4 className="OurProcess__title small-header">
            { titleSection.title }
          </h4>

          <div className="OurProcess__content">
            <p className="OurProcess__content-title">
              { contentSection.title }
            </p>

            <Description
              description={ contentSection.description }
              className="OurProcess__content-description"
            />
          </div>
        </div>
      </div>
    )
  }
  else {
    return null
  }

}

export default OurProcess;